import { render, staticRenderFns } from "./IconPlus.vue?vue&type=template&id=ffdbdf6a&scoped=true&"
import script from "./IconPlus.vue?vue&type=script&lang=js&"
export * from "./IconPlus.vue?vue&type=script&lang=js&"
import style0 from "./IconPlus.vue?vue&type=style&index=0&id=ffdbdf6a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdbdf6a",
  null
  
)

export default component.exports